module.exports = __webpack_public_path__ + "img/ubuntu-logo.9aa02929.svg";